import { useAtomValue } from 'jotai';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { unableToContinueHeadings } from '@consumer-frontend/nc-utils';
import { Container } from '@consumer-frontend/shared-ui';

import { unableToContinueReasonAtom } from '../../store';
import { NcFieldset } from '../NcFieldset';
import { NcLinkStyledAsButton } from '../NcLinkStyledAsButton';
import { NcSupportNumberLink } from '../NcSupportNumberLink';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/unable-to-continue-page.scss';

export const NcUnableToContinuePage: React.FC = () => {
  const unableToContinueReason = useAtomValue(unableToContinueReasonAtom);

  return (
    <Container className="nc-unable-to-continue-page" hasBoxShadow>
      <h1 className="h3">
        {unableToContinueHeadings[unableToContinueReason]}
      </h1>

      <p>Sign in with your password, or call us at <NcSupportNumberLink /> to continue.</p>

      <NcFieldset className="cta-buttons">
        <NcLinkStyledAsButton
          to={uiRoutes.legacyAH.signin}
          buttonText="Sign In with Password"
        />
      </NcFieldset>
    </Container>
  );
};
